import { render } from "./PropertieList.vue?vue&type=template&id=f4d35cd4"
import script from "./PropertieList.vue?vue&type=script&lang=js"
export * from "./PropertieList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__